export default "__VITE_ASSET__TftqcFtO__"